'use client';
import { isFunction } from '../../guards/isFunction/isFunction.js';

/**
 * Производит группировку объектов по ключу или по переданному условию.
 *
 * @param data - Однородный массив объектов произвольной структуры,
 * над которыми будет выполняться группировка.
 * @param condition - Ключ, по значениям которого будет выполняться группировка, либо функция,
 * определяющая, к какой группу должен быть отнесён тот или иной объект.
 *
 * @example Группировка объектов по значению для указанного ключа.
 * ```ts
 * groupBy(
 *     [
 *         { a: 'b', b: 0 },
 *         { a: 'b', b: 0 },
 *         { a: 1, b: 42 },
 *     ],
 *     'a',
 * )
 * /* {
 *  *   [1]: [{ a: 1, b: 42 }],
 *  *   b: [
 *  *       { a: 'b', b: 0 },
 *  *       { a: 'b', b: 0 },
 *  *   ],
 *  * }
 *  * /
 * ```
 *
 * @example Группировка по условию.
 * ```
 * groupBy(
 *     [{ a: 1 }, { a: -1 }, { a: 2 }],
 *     item => item > 0 ? 'positive' : 'negative',
 * )
 * /* {
 *  *   positive: [{ a: 1 }, { a: 2 }],
 *  *   negative: [{ a: -1 }],
 *  * }
 *  * /
 * ```
 *
 * @unstable
 * */ const groupBy = (data, condition)=>{
    if (!data) {
        return {};
    }
    const groups = {};
    const splitter = isFunction(condition) ? (item)=>condition(item) : (item)=>item[condition];
    for (const item of data){
        const category = splitter(item);
        if (!groups[category]) {
            groups[category] = [];
        }
        groups[category].push(item);
    }
    return groups;
};

export { groupBy };
//# sourceMappingURL=groupBy.js.map
